import { Box } from "@mui/material";
import ValutaServizioIframe from "./ValutaServizioIframe";
import { useAppContext } from "GlobalContext";

const componentRegistry = {
  ValutaServizioIframe,
};

export default function ValutaServizioRender({ ...rest }) {
    const { valutazione } = useAppContext()
    const { componente, ...props } = (valutazione || {});
    const Comp = componentRegistry[componente];

    if (!Comp) {
      console.warn(`Componente non trovato: ${componente}`);
      return <></>;
    }

    return (<Box sx={{ p: 4 , bgcolor: 'primary.main', boxShadow: 3  }} className="questionario">
        <Comp {...props} {...rest} />
      </Box>)
  
}
